import * as St from './SlabViewerMatAttr.styles';

import { Feature } from '~/core/models';
import SlabViewerTooltip from '~molecules/SlabViewerTooltip';

interface SlabViewerMatAttrProps {
  materialAttributes: Feature[];
}

const SlabViewerMatAttr = ({
  materialAttributes,
}: SlabViewerMatAttrProps): JSX.Element | null =>
  materialAttributes.length ? (
    <St.FeaturesContainer>
      {materialAttributes.map((feature) => (
        <SlabViewerTooltip key={feature.value} feature={feature} />
      ))}
    </St.FeaturesContainer>
  ) : null;

export default SlabViewerMatAttr;
